<template>
  <b-container fluid>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-2 m-auto">
                <select-field
                    v-model="perPage"
                    property="per-page-select"
                    name="Nombre de pages"
                    :options="pageOptions"
                />
              </div>
              <div class="col-md-6 m-auto">
                <text-button-field
                    v-model="filter"
                    property="filter"
                    name="Type de recherche"
                    :disabled="!filter"
                />
              </div>
              <div class="col-md-3 m-auto">
                <checkbox-field
                    class="mt-1"
                    v-model="filterOn"
                    property="filterOn"
                    name="Filtrer"
                    :options="filters"
                    index="value"
                />
              </div>
            </div>
          </div>
        </div>
      
      </div>

      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card mt-3">
          <div class="card-body">
            <!-- Main table element -->
            <div class="row">
              <div class="col-md-12 col-sm-12" v-if="orders">
                <b-table
                    :items="orders"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    stacked="sm"
                    :busy="!apiRslt.fetch.success"
                    show-empty
                    responsive
                    @filtered="onFiltered"
                >
                  <template #cell(client)="row">
                    {{ row.item.client.firstname }} {{ row.item.client.lastname }}
                  </template>
                  <template #cell(createdAt)="row">
                    {{ row.item.createdAt | formatDateShort }}
                  </template>
                  <template #cell(state)="row">
                    <state-tag :state="row.item.state" />
                  </template>
                  <template #cell(statusPaid)="row">
                    <paiement-tag :payment="row.item.statusPaid" />
                  </template>
                  <template #cell(actions)="row">
                    <router-link class="btn btn-light mr-1 text-center" :to="{ name: 'order', params: { id: row.item.id }}">
                      <i class="fa fa-list-alt" aria-hidden="true"></i>
                    </router-link>
                  </template>
                </b-table>
                <div class="mb-2 text-end">
                  Nombre total: <b>{{ orders.length }} élement(s)</b>
                </div>
              </div>
              <div class="col-md-12 col-sm-12 m-auto">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="orders.length"
                    :per-page="perPage"
                    pills
                    class="my-0 justify-content-center"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import {mapState, mapActions} from "vuex";
import {table} from "@/core/mixins";
import StateTag from "@/modules/order/components/StateTag";
import PaiementTag from "@/modules/order/components/PaiementTag";

export default {
  name: 'Orders',
  components:{
    StateTag,
    PaiementTag
  },
  mixins:[table],
  data(){
    return {
      fields:[
        { key: 'id', label: '#', sortable: true },
        { key: 'reference', label: 'Référence', sortable: true },
        { key: 'client', label: 'Client', sortable: true },
        { key: 'createdAt', label: 'Date', sortable: true },
        { key: 'statusPaid', label: 'Etat paiement', sortable: true },
        { key: 'actions', label: 'Actions' }
      ],
      filters:[
        { text: 'Référence', value:'reference' },
        { text: 'Client', value: 'client' },
        { text: 'Etat', value: 'state'} // Todo: filter custom state select
      ],
    }
  },
  computed: {
    ...mapState('auth',['fullUser']),
    ...mapState('orders',['orders','apiRslt'])
  },
  created() {
    this.loadOrders()
  },
  methods: {
    ...mapActions('notifications',['send']),
    ...mapActions('orders', ['loadOrders'])
  },
}
</script>
<style>
thead > tr > th {
  padding: 1.3rem !important;
}
tbody > tr > td {
  padding: 1.3rem !important;
}
ul {
  list-style-type: none;
}
</style>
